/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AcceptFriendInviteBody
 */
export interface AcceptFriendInviteBody {
    /**
     * The UUID invite code from the friend invite link
     * @type {string}
     * @memberof AcceptFriendInviteBody
     */
    inviteCode: string;
}

/**
 * Check if a given object implements the AcceptFriendInviteBody interface.
 */
export function instanceOfAcceptFriendInviteBody(value: object): value is AcceptFriendInviteBody {
    if (!('inviteCode' in value) || value['inviteCode'] === undefined) return false;
    return true;
}

export function AcceptFriendInviteBodyFromJSON(json: any): AcceptFriendInviteBody {
    return AcceptFriendInviteBodyFromJSONTyped(json, false);
}

export function AcceptFriendInviteBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcceptFriendInviteBody {
    if (json == null) {
        return json;
    }
    return {
        
        'inviteCode': json['inviteCode'],
    };
}

export function AcceptFriendInviteBodyToJSON(json: any): AcceptFriendInviteBody {
    return AcceptFriendInviteBodyToJSONTyped(json, false);
}

export function AcceptFriendInviteBodyToJSONTyped(value?: AcceptFriendInviteBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'inviteCode': value['inviteCode'],
    };
}

